'use strict';

module.exports = require('./Checkbox');


/*****************
 ** WEBPACK FOOTER
 ** ./~/rc-checkbox/lib/index.js
 ** module id = 220
 ** module chunks = 0
 **/